export const OPTIONS_HEADER = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "9784e9059dmsh5554ae325dc1592p180343jsn0821abf68f76",
    "X-RapidAPI-Host": "hotels-com-provider.p.rapidapi.com",
  },
};

export const API_KEY = "84c36219a76b42c5a389a19e2f2602d2";
export const RES_PER_PAGE = 5;
